/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2eb20586"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2eb20586&lang=less"

import exportComponent from "D:\\VUE\\development\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__